/* OPERATIONS = REDUX THUNKS

This file defines the public interface of the duck -- what can be dispatched from components
Simple operations are just about forwarding an action creator, ex: simpleQuack
Complex operations involve returning a thunk that dispatches multiple actions in a certain order, ex: complexQuack

*/

import store from '../store';
import * as actions from './actions';
import api from '../../utils/api/base_api';
import surchxApi from '../../utils/api/surchx_base_api';
import surchxApiTest from '../../utils/api/surchx_base_api-test';
import { checkToken } from '../../utils/token-utils';
import moment from 'moment';

const getMerchantBearerToken = () => {
	return dispatch => {
		api.defaults.headers['Authorization'] =
			'Bearer ' + store.getState().tokenReducer.tokens.loginToken;
		return api
			.post('token', { siteMode: true })
			.then(response => {
				dispatch(actions.setMerchantBearerToken(response.data.bearerToken));
			})
			.catch(error => {
				throw error;
			});
	};
};

const getMerchantBearerTokenTest = () => {
	return dispatch => {
		api.defaults.headers['Authorization'] =
			'Bearer ' + store.getState().tokenReducer.tokens.loginToken;
		return api
			.post('token', { siteMode: false })
			.then(response => {
				dispatch(actions.setMerchantBearerTokenTest(response.data.bearerToken));
			})
			.catch(error => {
				throw error;
			});
	};
};

const getSurchxApiProdTokenAction = data => {
	const { category, tokenLabel } = data;
	return async dispatch => {
		await checkToken(
			store.getState().tokenReducer.tokens.bearerToken,
			true
		).then(async bearerToken => {
			const config = {
				headers: {
					Authorization: `Bearer ${bearerToken}`,
				},
			};

			surchxApi
				.post(
					`/merchant/${
						store.getState().userReducer.user.id
					}/token`,
					{
						data: createTokenData(data),
					},
					config
				)
				.then(response => {
					const prod_token = response.data.token;

					api.defaults.headers['Authorization'] =
						'Bearer ' +
						store.getState().userReducer.user.loginToken;
					api.post('add_prod_token', { prod_token })
						.then(response => {
							// console.log('response: ', response);
							dispatch(
								actions.pushSurchxApiProdToken(prod_token)
							);
						})
						.catch(error => {
							throw error;
						});
				})
				.catch(error => {
					throw error;
				});
		});
	};
};

const getSurchxApiTestTokenAction = data => {
	return async dispatch => {
		await checkToken(store.getState().tokenReducer.tokens.bearerTokenTest, false).then(
			async bearerToken => {
				const config = {
					headers: {
						Authorization: `Bearer ${bearerToken}`,
					},
				};
				const expiration = moment()
					.add(2, 'months')
					.unix();

				surchxApiTest
					.post(
						`/merchant/${
							store.getState().merchantReducer.merchant.merchant_id_test
						}/token`,
						{
							data: createTokenData(data),
							expiration,
						},
						config
					)
					.then(response => {
                        const test_token = response.data.token;
                        // console.log('test_token: ', test_token);

						api.defaults.headers['Authorization'] =
							'Bearer ' +
							store.getState().tokenReducer.tokens.loginToken;
                        api.post('add_test_token', { test_token })
							.then(response => {
                                // console.log('response: ', response);
                                // console.log('test_token: ', test_token);
								dispatch(
									actions.pushSurchxApiTestToken(test_token)
								);
							})
							.catch(error => {
								throw error;
							});
					})
					.catch(error => {
						throw error;
					});
			}
		);
	};
};

const createTokenData = (data) => {
    const { category, tokenLabel } = data;
    let dataString = store.getState().merchantReducer.merchant.name;
    let dataToReturn = [];

    // dataToReturn.push(store.getState().merchantReducer.merchant.name);
    if (category !== '') {
        // dataToReturn.push(category);
        dataString += ` - ${category}`
    }
    if (tokenLabel !== '') {
        // dataToReturn.push(tokenLabel);
        dataString += ` - ${tokenLabel}`
    }
    
    dataToReturn.push(dataString);

    return dataToReturn;
}

export { getMerchantBearerToken, getMerchantBearerTokenTest, getSurchxApiProdTokenAction, getSurchxApiTestTokenAction };



// WEBPACK FOOTER //
// ./src/redux/tokens/operations.js